import React, { PropTypes } from 'react'

import PrintTemplate from 'components/PrintTemplate'

const Print  = ({ children }) => (
  <PrintTemplate>
    {children}
  </PrintTemplate>
)

Print.propTypes = {
  children: PropTypes.any,
}

export default Print



// WEBPACK FOOTER //
// ./src/containers/Print/index.js